/**
 * Monetizable describes whether NerdWallet expects the referral to
 * generate revenue. This is an enumeration of possible values for this in the
 * `BetaProductShoppingFinish` event.
 *
 * @enum {string} Monetizable -
 * @see https://github.com/NerdWallet/schemas/blob/master/protobuf/src/event/BetaProductShoppingFinish.proto#L34
 */
export default {
  no: 'NO',
  noBecauseOfLimit: 'NO_BECAUSE_OF_LIMIT',
  yesAssumed: 'YES_ASSUMED'
};